import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { coins, getNetworkLabel } from "../../../constants/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { BiMessageSquareAdd } from "react-icons/bi";
import ClipLoader from "react-spinners/ClipLoader";
import { useQuery, useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import { useUser } from "../../../context/user-context";
import GetRates from "../../../components/utils/GetRates";
import { FaCaretDown } from "react-icons/fa";

const SellFromExAddy = ({
  setOpenSellFromExAddy,
  setOpenSellFrom,
  setOpenSellTransfer,
  selectedCoinObj,
  setSelectedCoinObj,
  selectedNetwork,
  setSelectedNetwork,
}: any) => {
  const axiosInstance = useAuthAxios();
  const coinRate = GetRates(selectedCoinObj?.abbr?.toLowerCase());
  const [accountName, setAccountName] = useState<string>("");
  const { userDetails, refetch } = useUser();
  const [bankName, setBankName] = useState<string>("");
  const [bankNumber, setBankNumber] = useState<string>("");
  const [openBank, setOpenBank] = useState<boolean>(false);
  const [disableProceed, setDisableProceed] = useState<boolean>(false);
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const navigate = useNavigate();
  const [bankId, setBankId] = useState<string>("");
  // const getRate = async () => {
  //   const response = await axiosInstance.get(API.getRates);
  //   return response.data.data.rates;
  // };

  // const { data: rates } = useQuery({
  //   queryKey: ["get-rates"],
  //   queryFn: getRate,
  //   retry: 1,
  // });
  // console.log(userDetails);

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });

  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  const makeDefault = async ({ accountNumber, bankCode }: any) => {
    const response = await axiosInstance.put(API.makeDefaultBank(bankId), {
      accountNumber,
      bankCode,
    });
    return response.data;
  };

  const completeMakeDefault = useMutation({
    mutationFn: makeDefault,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setLoadingIndex(null);
      setTimeout(() => {
        setOpenBank(false);
      }, 1000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
      setLoadingIndex(null);
    },
  });
  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
    setSelectedCoinObj(coin);
    setSelectedNetwork("");
  };
  useEffect(() => {
    if (selectedCoinObj?.abbr) {
      setSelectedNetwork(selectedCoinObj?.networks[0]?.name);
    }
  }, [selectedCoinObj?.abbr]);
  const location = useLocation();
  const handleNetworkChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedNetwork(e.target.value);
  };

  useEffect(() => {
    if (
      !userDetails?.user?.wallets ||
      userDetails?.user?.wallets?.length === 0
    ) {
      setDisableProceed(true);
      toast.error(
        "You don't have any wallet to sell from, please refresh the page"
      );
    } else {
      setDisableProceed(false);
    }
  }, [userDetails]);

  const resolveBankName = (bank: any) => {
    const matchedBank =
      allBanks?.data?.find(
        (allBank: any) => allBank.bankCode === bank.bankCode
      ) ||
      allOldBanks?.data?.find((newBank: any) => newBank.code === bank.bankCode);

    return (
      matchedBank?.bankName ||
      matchedBank?.name ||
      bank.bankName ||
      "Unknown Bank"
    );
  };
  useEffect(() => {
    if (
      userDetails?.user?.banks?.length > 0 &&
      allBanks?.data &&
      allOldBanks?.data
    ) {
      const defaultBank =
        userDetails?.user?.banks.find((bank: any) => bank.isDefault) ||
        userDetails?.user?.banks[0];

      setBankNumber(defaultBank.accountNumber);
      setBankName(resolveBankName(defaultBank));
      setAccountName(defaultBank.accountName);
    }
  }, [userDetails?.user?.banks, allBanks?.data, allOldBanks?.data]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              if (location.pathname === "/trade") {
                setOpenSellFromExAddy(false);
              } else {
                setOpenSellFromExAddy(false);
                setOpenSellFrom(true);
              }
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Sell Crypto
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className="mt-4">
            <h4 className="text-[14px] font-bold text-gray-500 ">
              I want to sell
            </h4>
            <div className="w-full flex justify-between items-start border border-[#EAEAEA] dark:border-gray-700 shadow  rounded-[4px] p-3 mt-3">
              <div className="w-full">
                <div className="w-full flex gap-2 justify-start items-center relative">
                  {selectedCoinObj?.abbr && (
                    <div className="flex justify-center items-center w-[26px] h-[24px] rounded-full">
                      <img
                        src={selectedCoinObj?.logo}
                        className="w-full h-full bg-cover"
                        alt=""
                      />
                    </div>
                  )}

                  <div className={`relative w-full`}>
                    <select
                      value={selectedCoinObj?.abbr || ""}
                      onChange={handleCoinChange}
                      className="outline-none w-full text-[14px] font-semibold text-gray-900 bg-transparent dark:text-gray-200 appearance-none pr-6"
                    >
                      <option value="" disabled>
                        Select a coin
                      </option>
                      {coins.map((coin: any, index: any) => (
                        <option key={index} value={coin.abbr}>
                          {coin.name}
                        </option>
                      ))}
                    </select>

                    {/* Custom Icon */}
                    <FaCaretDown className="absolute right-0 top-[50%] -translate-y-1/2 pointer-events-none text-gray-900 dark:text-gray-200 text-[20px]" />
                  </div>
                </div>
                <h4 className="text-[12px] text-gray-500 font-medium mt-2 pl-2">
                  {selectedCoinObj?.abbr}
                </h4>
              </div>
            </div>
          </div>
          <h4 className="text-[11px] text-[#BE6B0A] font-semibold text-left mt-3">
            1$ ~ ₦{coinRate ? coinRate : "--"}
          </h4>
          <div className="mt-6">
            <h4 className="text-[14px] font-bold text-gray-500 ">Network</h4>
            <div className="w-full cursor-pointer border border-[#EAEAEA] dark:border-gray-700 shadow  rounded-[4px] p-3 mt-3 flex justify-between items-center relative">
              <select
                value={selectedNetwork}
                onChange={handleNetworkChange}
                className="outline-none w-full text-[14px] font-semibold text-gray-700 bg-transparent dark:text-gray-300 appearance-none "
              >
                <option value="" disabled>
                  Select a Network
                </option>
                {selectedCoinObj?.networks.map((network: any, index: any) => (
                  <option key={index} value={network.name}>
                    {getNetworkLabel(network.name)}
                  </option>
                ))}
              </select>
              <FaCaretDown className="absolute right-3 top-[50%] -translate-y-1/2 pointer-events-none text-gray-900 dark:text-gray-200 text-[20px]" />
            </div>
          </div>
          <div className="mt-4 w-full relative">
            <h4 className="text-[14px] font-bold text-gray-500 ">
              Destination
            </h4>
            <div
              onClick={() => {
                setOpenBank((prev) => !prev);
              }}
              className="w-full cursor-pointer border border-[#EAEAEA] dark:border-gray-700 shadow  rounded-[4px] p-3 mt-3 flex justify-between items-center"
            >
              <div className="flex justify-start items-center gap-3">
                <div>
                  <h4 className="text-[13px] text-black font-semibold dark:text-gray-200">
                    {bankNumber} - {bankName}
                  </h4>
                  <h4 className="text-[11px] text-gray-500 font-medium mt-1 dark:text-gray-50">
                    {accountName}
                  </h4>
                </div>
              </div>
              <FaCaretDown className="text-[20px] text-gray-700 dark:text-gray-300" />
            </div>
            {openBank && (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-3 h-[250px] border border-gray-200 dark:border-gray-600 overflow-auto bg-white dark:bg-gray-800 ">
                {userDetails?.user?.banks.length >= 1 ? (
                  <div className="w-full">
                    {userDetails?.user?.banks
                      .sort((a: any, b: any) => b.isDefault - a.isDefault)
                      .map((bank: any, index: number) => {
                        const matchedBank =
                          allBanks?.data.find(
                            (allBank: any) => allBank.bankCode === bank.bankCode
                          ) ||
                          allOldBanks?.data.find(
                            (newBank: any) => newBank.code === bank.bankCode
                          );

                        return (
                          <div
                            key={index}
                            onClick={() => {
                              if (bank.isDefault) {
                                setBankNumber(bank.accountNumber);
                                setBankName(
                                  matchedBank?.bankName || matchedBank?.name
                                );
                                setAccountName(bank.accountName);

                                setOpenBank(false);
                              } else {
                                setBankId(bank._id);
                                setLoadingIndex(index);
                                setAccountName(bank.accountName);

                                setTimeout(() => {
                                  completeMakeDefault.mutate({
                                    accountNumber: bank.accountNumber,
                                    bankCode: bank.bankCode,
                                  });
                                  setBankNumber(bank.accountNumber);
                                  setBankName(
                                    matchedBank?.bankName || matchedBank?.name
                                  );
                                }, 500);
                              }
                            }}
                            className={
                              bank.isDefault
                                ? "w-full cursor-pointer flex justify-start p-4 border border-secondary_button rounded-xl items-center gap-4"
                                : "w-full cursor-pointer flex justify-start items-center gap-4 p-4 border-b border-gray-200 dark:border-gray-600"
                            }
                          >
                            {loadingIndex === index ? (
                              <ClipLoader color="#5E91FF" size={20} />
                            ) : (
                              <div
                                className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full  ${
                                  bank.isDefault
                                    ? "border-secondary_button "
                                    : "bg-transparent border-[#505050]"
                                } border `}
                              >
                                <div
                                  className={`w-full h-full rounded-full  ${
                                    bank.isDefault
                                      ? " bg-secondary_button "
                                      : "bg-transparent "
                                  } `}
                                />
                              </div>
                            )}
                            <div>
                              <h4 className="text-[10px] font-bold text-gray-700 dark:text-gray-300">
                                {bank.accountName}
                              </h4>
                              <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
                                {bank.accountNumber} -{" "}
                                {matchedBank?.bankName ||
                                  matchedBank?.name ||
                                  "Unknown Bank"}
                              </h4>
                            </div>
                          </div>
                        );
                      })}
                    ={" "}
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      navigate("/settings");
                    }}
                    className={
                      "p-3 text-[14px] mt-8 mds:mt-0 transition ease-out duration-300   rounded-xl bg-secondary_button text-white gap-4 flex justify-center items-center"
                    }
                  >
                    <h4> Add bank</h4>
                    <BiMessageSquareAdd className="text-2xl" />
                  </button>
                )}
              </div>
            )}
          </div>

          <button
            onClick={() => {
              setOpenSellFromExAddy(false);
              setOpenSellTransfer(true);
            }}
            disabled={
              !coinRate || !selectedNetwork || !bankNumber || disableProceed
            }
            className={
              !coinRate || !selectedNetwork || !bankNumber || disableProceed
                ? "mt-8 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl"
                : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
            }
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default SellFromExAddy;
